<template>
  <div class="meeting-sign">
    <div class="meeting-header">会议报名</div>
    <div class="meeting-success-body">
      <p class="success-icon"><i class="el-icon-success"></i></p>
      <p class="success-txt">报名成功</p>
      <span>欢迎您来参加会议!</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "cache-result",
  methods: {
    back() {
      this.$router.replace({ name: "SignPage" });
    }
  },
  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.back, false);
    }
  },
  beforeDestroy() {
    //在组件生命周期结束的时候销毁。
    window.removeEventListener("popstate", this.back);
  }
};
</script>
<style>
.meeting-sign {
  background-color: #f9f9f9;
  height: 100vh;
  position: relative;
}
.meeting-header {
  background-color: #b6242b;
  color: #ffffff;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
}
.meeting-success-body {
  text-align: center;
  margin-top: 20%;
  background-color: transparent;
}
.meeting-success-body p {
  margin-bottom: 30px;
}
.meeting-success-body .success-icon i {
  font-size: 200px;
  color: #b6242b;
}
.meeting-success-body .success-txt {
  font-size: 36px;
}
.meeting-success-body span {
  color: #6e6f73;
}
</style>



// WEBPACK FOOTER //
// src/view/resultPage.vue